<template>
  <v-dialog v-model="exibir" persistent max-width="900">
    <v-card>
      <v-card-title class="primary modal-title">
        <span class="white--text">Reenviar documentos PNCP</span>
        <v-spacer/>
        <v-btn icon @click="fecharModal">
          <v-icon size="20" color="white">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-4">
        <v-data-table
            :headers="colunas"
            :items="anexosPublicos"
            hide-actions
            class="az-table-list"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{ props.item.arquivoNome }}</td>
              <td>{{ props.item.situacaoEnvio | situacaoEnvioAnexo }}</td>
              <td>
                <span v-if="props.item.motivo">{{ props.item.motivo }}</span>
                <span v-else>--</span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <div class="az-actions-form actions-modal">
        <button class="action-secundary-button" @click="fecharModal">Fechar</button>
        <button class="action-primary-button" @click="reenviarDocumentos">Reenviar documentos PNCP</button>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalReenviarDocumentoPncp',
  filters: {
    situacaoEnvioAnexo(situacao) {
      const situacoes = {
        'PUBLICADO': 'Publicado',
        'ERRO': 'Erro',
        'NAO_ENVIADO': 'Não enviado'
      }
      return situacoes[situacao] || situacao || '--'
    }
  },
  props: {
    exibir: {
      type: Boolean,
      default: false
    },
    anexos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      colunas: [
        { text: 'Nome', align: 'left', sortable: false, value: 'arquivoNome', class: 'primary--text' },
        { text: 'Situação no PNCP', align: 'left', sortable: false, value: 'situacaoEnvio', class: 'primary--text' },
        { text: 'Motivo da situação no PNCP', align: 'left', sortable: false, value: 'motivo', class: 'primary--text' }
      ]
    }
  },
  computed: {
    anexosPublicos() {
      return (this.anexos).filter(anexo => anexo && anexo.situacao === 'ATIVO')
    }
  },
  methods: {
    fecharModal() {
      this.$emit('fechar')
    },
    reenviarDocumentos() {
      const anexosComErro = this.anexos.filter(anexo => anexo.situacaoEnvio === 'ERRO')

      if (anexosComErro.length > 0) {
        this.$emit('reenviar', anexosComErro)
      } else {
        this.mostrarNotificacaoErro('Não há documentos para enviar, pois todos os documentos estão publicados.')
        this.fecharModal()
      }
    }
  }
}
</script>
